import styled from 'styled-components'

export const Wrapper = styled.div`
min-height: 100vh;
padding-top: var(--navBarHeight);
display: flex;
justify-content: center;
align-items: center;
`;